import { createFileRoute } from '@tanstack/react-router'

import { ReportPage } from '@/components/reports/report-page'
import { StaffTab } from '@/components/reports/staff-tab'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/reports/staff')({
    component: StaffReportPage,
})

function StaffReportPage() {
    return (
        <ReportPage title={m.report_page_title_staff()}>
            <StaffTab />
        </ReportPage>
    )
}
